module.exports = __webpack_public_path__ + "img/uploadBg.735d0b1b.png";